export default __webpack_public_path__ + "static/media/overlay-3.9c1960ef.jpg";